/**
 * PolicyEmptyState Component
 * Displays a centered message when no policies match the current filters
 */

import React from 'react';
import { Text } from '@fluentui/react-components';
import { PolicyTabType } from '../types';

type PolicyEmptyStateProps = {
  selectedTab: PolicyTabType;
  /** Custom secondary message (optional) */
  message?: string;
  /** Custom title (optional). Defaults to "No policies found". */
  title?: string;
};

const EMPTY_STATE_STYLES = {
  container: {
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px 20px',
    textAlign: 'center' as const,
  },
  title: {
    fontWeight: 500,
    marginBottom: 4,
  },
  subtitle: {
    color: '#6b7280',
  },
};

export const PolicyEmptyState: React.FC<PolicyEmptyStateProps> = ({ 
  selectedTab, 
  message,
  title,
}) => {
  const policyType = selectedTab === 'DLP' ? 'DLP' : 'Auto Label';
  const defaultMessage = `No ${policyType} policies available`;
  
  return (
    <div style={EMPTY_STATE_STYLES.container}>
      <Text size={400} style={EMPTY_STATE_STYLES.title}>
        {title || 'No policies found'}
      </Text>
      <Text size={300} style={EMPTY_STATE_STYLES.subtitle}>
        {message || defaultMessage}
      </Text>
    </div>
  );
};

export default PolicyEmptyState;
